import { LogOut } from "lucide-react";

interface Props {
  iniciais: string;
  nome: string;
  role: string;
  onLogout: () => void;
}

export function UserFooter({ iniciais, nome, role, onLogout }: Props) {
  return (
    <div className="border-t border-white/10 p-3 flex items-center gap-3">
      <div className="flex-shrink-0 w-9 h-9 rounded-full bg-indra-turquesa text-indra-azul flex items-center justify-center font-bold text-xs">
        {iniciais}
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm text-white truncate">{nome}</div>
        <div className="text-[11px] text-white/40">{role}</div>
      </div>
      <button
        type="button"
        onClick={onLogout}
        className="flex-shrink-0 text-white/40 hover:text-indra-negativo transition-colors p-1 rounded"
        title="Sair"
      >
        <LogOut size={16} />
      </button>
    </div>
  );
}
